import { Text, ButtonComponent } from "@iiht/components";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PageNotFoundIcon } from "../../../icons";
import "./NotFoundPage.scss";
import { localStorageHelper } from "../../../utils";

const NotFoundPage = ({ invalidTenant }) => {
  const { t } = useTranslation();
  const isPortalLogin = JSON.parse(localStorageHelper.get("is_portal_login"));

  return (
    <>
      <div className="display-flex flex-direction-column h-100 w-100 justify-center items-center">
        <PageNotFoundIcon />
        <Text className="sub-heading-text font-weight-300">{t("common.404")}</Text>
        <Text className="sub-heading-text font-weight-300">{t("common.notFoundContent")}</Text>
        <Text className="sub-heading-text-three font-weight-normal">{t("common.notFoundContent_text")}</Text>
        {!invalidTenant && isPortalLogin && (
          <ButtonComponent className="btn-paddign-top">
            <Link to={"/dashboard"}>{t("common.goBackDashboard")}</Link>
          </ButtonComponent>
        )}
      </div>
    </>
  );
};

export default NotFoundPage;
